export var PreferenceOverrideSourceEnum;
(function (PreferenceOverrideSourceEnum) {
    PreferenceOverrideSourceEnum["SUBSCRIBER"] = "subscriber";
    PreferenceOverrideSourceEnum["TEMPLATE"] = "template";
    PreferenceOverrideSourceEnum["WORKFLOW_OVERRIDE"] = "workflowOverride";
})(PreferenceOverrideSourceEnum || (PreferenceOverrideSourceEnum = {}));
